import { MissionGroupType } from '@web/gql/graphql'
import nClicks from '@web/libs/nlog/click/codes'

import ReceiptReviewMasterMissionCardGuide from './ReceiptReviewMasterMissionCardGuide'
import { CompletedMissionCardProps } from '../../MissionCard/CompletedMissionCard'
import { MissionCard, MissionCardProps } from '../../MissionCard/MissionCard'
import { ProgressMissionCardProps } from '../../MissionCard/ProgressMissionCard'

const RECEIPT_REVIEW_MISSION_GROUP_TYPE = [MissionGroupType.ReviewMaster]

export const isReceiptReviewMissionGroup = (missionCard: MissionCardProps) => {
  return RECEIPT_REVIEW_MISSION_GROUP_TYPE.includes(missionCard.missionGroupType)
}

export const getReceiptReviewMissionCardClickArea = (
  missionCard: MissionCardProps,
): (CompletedMissionCardProps['nClickArea'] & ProgressMissionCardProps['nClickArea']) | undefined => {
  const stepIndex = MissionCard.getCurrentStepIndex(missionCard) ?? 0
  const step = stepIndex + 1

  if (missionCard.missionGroupType === MissionGroupType.ReviewMaster) {
    if (step === 1) {
      return {
        openMore: nClicks.mission.DONECARD1,
        closeMore: nClicks.mission.DONEXCARD1,
        openGuide: nClicks.mission.TIPCARD1,
        closeGuide: nClicks.mission.TIPXCARD1,
        openPreview: nClicks.mission.MORECARD1,
        closePreview: nClicks.mission.MOREXCARD1,
      }
    }

    if (step === 2) {
      return {
        openMore: nClicks.mission.DONECARD2,
        closeMore: nClicks.mission.DONEXCARD2,
        openGuide: nClicks.mission.TIPCARD2,
        closeGuide: nClicks.mission.TIPXCARD2,
        openPreview: nClicks.mission.MORECARD2,
        closePreview: nClicks.mission.MOREXCARD2,
      }
    }

    if (step === 3) {
      return {
        openMore: nClicks.mission.DONECARD3,
        closeMore: nClicks.mission.DONEXCARD3,
        openGuide: nClicks.mission.TIPCARD3,
        closeGuide: nClicks.mission.TIPXCARD3,
      }
    }
  }

  if (missionCard.missionGroupType === MissionGroupType.NatureCategoryReview) {
    return {
      openMore: nClicks.mission.DONECARD10,
      closeMore: nClicks.mission.DONEXCARD10,
      openGuide: nClicks.mission.TIPCARD10,
      closeGuide: nClicks.mission.TIPXCARD10,
    }
  }

  if (missionCard.missionGroupType === MissionGroupType.VideoReview) {
    return {
      openMore: nClicks.mission.DONECARD11,
      closeMore: nClicks.mission.DONEXCARD11,
      openGuide: nClicks.mission.TIPCARD11,
      closeGuide: nClicks.mission.TIPXCARD11,
    }
  }

  return undefined
}

export const ReceiptReviewMissionCardGuide = ({ missionCard }: { missionCard: MissionCardProps }) => {
  if (missionCard.missionGroupType === MissionGroupType.ReviewMaster) {
    return <ReceiptReviewMasterMissionCardGuide missionCard={missionCard} />
  }

  if (missionCard.guide) return <>{missionCard.guide}</>

  return null
}
